module.exports = __webpack_public_path__ + "img/星裙币.9d5cdbf4.png";